import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import * as Sentry from '@sentry/browser';

import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, pluck, switchMap, withLatestFrom } from 'rxjs/operators';

import { environment } from '@app-env/environment';
import { ApiResponse } from '@app/core/models';
import { ShippingPricesAPI } from '@app/models/prices';

import * as ShippingPriceActions from './actions';
import * as InputsStore from '@app/shared/store/inputs';
import { transformShippingPrices } from '@app/models/prices.utils';

@Injectable()
export class ShippingPricesEffects {
	//  implements OnInitEffects {

	load$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(ShippingPriceActions.load),
			withLatestFrom(this.store.select(InputsStore.selectors.selectLanguage)),
			switchMap(([, lang]) =>
				this.httpClient.get<ApiResponse<ShippingPricesAPI>>(environment.API_URL + `calculator/get-data?lang=${lang}`).pipe(
					pluck('data'),
					map(response => ({
						...response,
						// extraServices: response.extraServices.filter(extraService => extraService.priceType === 'simple'),
					})),
					map(transformShippingPrices),
					map(response => ShippingPriceActions.loadSuccess({ prices: response })),
					catchError((error: HttpErrorResponse) => {
						Sentry.withScope(scope => {
							scope.setTag('module', 'site');
							scope.setExtra('error', error);
							Sentry.captureMessage('API error');
						});
						return of(ShippingPriceActions.loadFailed());
					})
				)
			)
		);
	});

	constructor(private actions$: Actions, private httpClient: HttpClient, private store: Store) {}

	// ngrxOnInitEffects(): Action {
	// 	return ShippingPriceActions.load();
	// }
}
